<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    溪头站<br>
站点介绍<br>
溪头站位于宝安区松岗镇沙江路与规划溪头路交叉口以西，沿沙江路路中（偏北）呈东西向布置，东接松岗站，西接松岗公园站。溪头站为地下二层岛式车站，地下一层为站厅层，地下二层为站台层，设备区位于公共区的东西两端。站址周边规划以商业、居住和政府社团用地为主。溪头站设置有A、B、C、D共4个出入口，其中B出入口为主要紧急出入口，C为备用紧急出入口。站厅D出入口处设置有公共男洗手间、女洗手间和残疾人洗手间各一间，方便非付费区乘客使用。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:22	23:01	6号线	3分24秒	6分20秒<br>
松岗	06:24	00:10	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:21	23:01	6号线	4分45秒	6分钟<br>
松岗	06:24	00:10	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:21	00:01	6号线	4分45秒	6分钟<br>
松岗	06:24	01:10	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
沙江路北侧（东）、深圳市松岗人民医院、坑尾村<br><br>
B出入口:<br>
沙江路北侧（西）、沙溪小学 ，天源隆超市<br><br>
C出入口:<br>
沙江路南侧（西），农村商业银行<br><br>
D出入口:<br>
沙江路南侧（东），星港城，百佳华商场<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 松岗人民医院南站<br>
B980路,M494路,M512路,M488,M178<br><br>
B出入口:<br>
公交站名： 宝溪综合市场站<br>
M512路,M513路,B980路,M178,M488,M494路<br><br>
C出入口:<br>
公交站名： 宝溪综合市场站<br>
M512路,M513路,B980路,M178,M488,M494路<br><br>
D出入口:<br>
公交站名： 松岗人民医院南站<br>
B980路,M494路,M512路，M513路,M494路,M488<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>